import { render } from "./Portal.vue?vue&type=template&id=0d43d8b2"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"

import "./Portal.vue?vue&type=style&index=0&id=0d43d8b2&lang=scss"

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__